import Bronze from 'bronze';
import { cloneDeep } from 'lodash-es';
import makeDisplay from './makeDisplay'

const id = new Bronze();

export default function(cells, table) {
	return new Promise(resolve => {
		const build = cloneDeep(table);

		let picklists = build.schema.columns.map(col => {
			if (!col.picklistKey) return null;
			let picklist = build.picklists.find(list => list.picklistKey === col.picklistKey);
			return picklist;
		});

		let rowId = id.generate();
		let row = cells.reduce((_row, _cell, i) => {
			let cell = {}
			if (build.schema.columns[i].editorType === 'picklist') {
				cell.key = _cell[1] || ''
			}
			else if (build.schema.columns[i].editorType === 'bool') {
				cell.bool = _cell[1] || ''
			}
			else {
				cell.value = _cell[1] || ''
				cell.filterTag = _cell[1] || ''
			}
			cell._added = true
			cell._id = id.generate();
			cell._row = rowId;
			cell._column = build.data.columnEnumeration[i];
			cell._regex = build.schema.columns[i].filterableTextRegExPattern;
			cell._filterable = build.schema.columns[i].filterable;
			cell._editorType = build.schema.columns[i].editorType;
			cell._display = makeDisplay(cell, picklists[i]);
			_row.push(cell)
			return _row;
		}, []);

		resolve([rowId, row]);
	});
}
